import {
  NOTIFICATIONS_QUERY_KEY,
  NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY,
} from "@frontend-shared/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { notificationsApi } from "@/api/services";

export const useMarkAllAsRead = () => {
  const { t } = useTranslation("notifications");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => notificationsApi.markAllAsRead(),
    onSuccess: () => {
      toast.success(t("mark_all_read"));
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEY] });
      queryClient.invalidateQueries({
        queryKey: [NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
      });
    },
    meta: {
      fallbackMessage: t("load_error"),
    },
  });
};
